<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Portabilité de numéro échouée</div>
    <div class="col-12">
        <br/>
        <div class="text-left">
            Votre demande de portabilité de numéro a échoué. Merci de vérifier votre RIO auprès de votre opérateur en
            appelant gratuitement le 3179.
            <br/>
            Une fois votre RIO vérifié, merci de le saisir ci-dessous et de choisir une nouvelle date de portabilité.
        </div>
        <br/>
        @if (formEgelirr) {
            <form [formGroup]="formEgelirr" (submit)="confirmation()">
                <div class="form-group pb-2">
                    <span class="bold-label-text float-left">Rio*</span>
                    <input type="text" class="form-control" formControlName="rio">
                    @if (formSubmitted && formEgelirr.controls.rio.errors) {
                        <p class="error-message">{{ getError('rio') }}</p>
                    }
                    @if (formSubmitted && invalidRio) {
                        <p class="error-message">Veuillez saisir un RIO valide. Vérifiez qu'il comporte 12
                            caractères</p>
                    }
                </div>
                <div class="form-group pb-2">
                    <span class="bold-label-text float-left">Date de portabilité*</span>
                    <select name="date" class="custom-select mt-3" formControlName="portabilityDate">
                        <option disabled></option>
                        @for (date of dates; track date) {
                            <option value="{{ date }}">{{ date }}</option>
                        }
                    </select>
                    @if (formSubmitted && formEgelirr.controls.portabilityDate.errors) {
                        <p class="error-message">{{ getError('portabilityDate') }}</p>
                    }
                </div>
                <div class="cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
                </div>
            </form>
        }
    </div>
</div>
